import { useEffect, useState } from 'react'
import { Text } from '@chakra-ui/react'
import meAtom from 'recoil/me'
import { useRecoilState } from 'recoil'
import { CommonModal } from './CommonModal'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from 'lib/apis'
import { useErrorHandler } from 'lib/apis/gigBizApi/errorHandler'
import { PRIVACY_POLICY_URL, TERMS_URL } from 'lib/link'

export const BranchTermsModals = () => {
  const errorHandler = useErrorHandler()

  const [me] = useRecoilState(meAtom)
  const [termsIsOpen, setTermsIsOpen] = useState(false)
  const [privacyPolicyIsOpen, setPrivacyPolicyIsOpen] = useState(false)

  // ここで条件を見て各モーダルを開くようにする
  useEffect(() => {
    if (!me?.branch) return
    me.branch.is_required_to_agree_on_term && setTermsIsOpen(true)
    me.branch.is_required_to_agree_on_privacy_policy &&
      setPrivacyPolicyIsOpen(true)
  }, [me])

  // 利用規約同意関数
  const sendTerms = useMutation(
    async () => {
      return apiClient.gigBizApi.branch_terms.terms()
    },
    {
      onSuccess: () => setTermsIsOpen(false),
      onError: errorHandler.default,
    },
  )

  // プライバシポリシー同意関数
  const sendPrivacyPolicy = useMutation(
    async () => {
      return apiClient.gigBizApi.branch_terms.privacyPolicy()
    },
    {
      onSuccess: () => setPrivacyPolicyIsOpen(false),
      onError: errorHandler.default,
    },
  )

  return (
    <>
      {/* 利用規約 */}
      {termsIsOpen && (
        <CommonModal
          isOpen={termsIsOpen}
          agreementType={'利用規約'}
          url={TERMS_URL}
          buttonLoading={sendTerms.isLoading}
          okFunction={() => sendTerms.mutate()}
          children={
            <Text>
              新規約をお読みの上、
              同意することで引き続きサービスをご利用いただけます。
            </Text>
          }
        />
      )}

      {/* プライバシポリシー */}
      {privacyPolicyIsOpen && (
        <CommonModal
          isOpen={privacyPolicyIsOpen}
          agreementType={'プライバシーポリシー'}
          url={PRIVACY_POLICY_URL}
          buttonLoading={sendPrivacyPolicy.isLoading}
          okFunction={() => sendPrivacyPolicy.mutate()}
          children={
            <Text>
              新しいプライバシーポリシーをお読みの上、
              同意することで引き続きサービスをご利用いただけます。
            </Text>
          }
        />
      )}
    </>
  )
}
